import ModalVideo from 'modal-video';

let isEscHandlerBound = false;

export default (el) => {
  const $trigger = $(el);
  const startRaw = String($trigger.data('videoStart') || '').trim();
  const start = Number.parseInt(startRaw, 10);
  const youtubeOptions = {
    autoplay: 1,
    rel: 0
  };

  if (Number.isFinite(start) && start > 0) {
    youtubeOptions.start = start;
  }

  new ModalVideo($trigger, {
    aria: {
      openMessage: 'Video Player (Press escape to close)',
      dismissBtnMessage: 'Close the video by clicking here'
    },
    youtube: youtubeOptions
  });

  if (isEscHandlerBound) {
    return;
  }

  isEscHandlerBound = true;

  // Close video modal on ESC key
  $(document).on('keydown.modalVideo', ({ key }) => {
    if (key === 'Esc' || key === 'Escape') {
      $('.js-modal-video-dismiss-btn').trigger('click');
    }
  });
};
